import { toDataURL } from 'qrcode';

export const getQrCodeDataUrlFromText = async (
  text: string,
  options: { width: number; margin: number; errorCorrectionLevel: 'low' | 'medium' | 'quartile' | 'high' | 'L' | 'M' | 'Q' | 'H' },
) => await toDataURL(text, options);
